import { SAVE_USER_NAME } from "./types";

export const saveUsername = username => {
    return {
        type: SAVE_USER_NAME,
        username
    }
}